var rmUtil = require("../rmlibrary_old/util");
var util = require("../util");
var PDFTextNode = require("./text");
var PDFNode = require("./node");

function newBlock(display) {
    return {
        display: display,
        children: [],
    };
}

function PDFBlockNode() {
    PDFNode.apply(this, arguments);

    this.drawHook = this.originalNode.drawHook;
    this.mixinHook = this.originalNode.mixinHook;
}
rmUtil.inherits(PDFBlockNode, PDFNode);

PDFBlockNode.prototype.setChildren = function (children) {
    this.children = this._splitBlockInline(children);
};

var displayMap = {
    block: "block",
    "list-item": "block",
    table: "block",
    inline: "inline",
    "inline-block": "inline",
};

PDFBlockNode.prototype._splitBlockInline = function (children) {
    var groups = [];
    var that = this;
    children.forEach(function (node) {
        if (!node.tagName && !node.content) return;

        var isTextNode = !node.tagName;
        var display = isTextNode ? "inline" : displayMap[node.styles.display || "inline"];

        if (!display) {
            util.warn("Display type '" + display + "' not supported in block.");
            return;
        }

        if (!groups.length) groups.push(newBlock(display));

        var lastGroup = groups[groups.length - 1];

        if (lastGroup.display !== display) {
            groups.push(newBlock(display));
            lastGroup = groups[groups.length - 1];
        }

        lastGroup.children.push(node);
    });
    children = [];
    groups.forEach(function (group) {
        if (group.display === "block") {
            children = children.concat(group.children);
        } else if (group.display === "inline") {
            var textBlock = new PDFTextNode({}, null, that, null, {});
            textBlock.setChildren(group.children);
            if (textBlock.hasContent()) children.push(textBlock);
        }
    });
    return children;
};

PDFBlockNode.prototype._getOptions = function () {
    var ret = {
        borderTopWidth: this.computedStyles.borderTopWidth,
        borderLeftWidth: this.computedStyles.borderLeftWidth,
        borderRightWidth: this.computedStyles.borderRightWidth,
        borderBottomWidth: this.computedStyles.borderBottomWidth,
        borderTopColor: this.computedStyles.borderTopColor,
        borderLeftColor: this.computedStyles.borderLeftColor,
        borderRightColor: this.computedStyles.borderRightColor,
        borderBottomColor: this.computedStyles.borderBottomColor,
        background: this.computedStyles.background,
        backgroundOpacity: this.computedStyles.backgroundOpacity,
        paddingLeft: this.computedStyles.paddingLeft,
        paddingRight: this.computedStyles.paddingRight,
        paddingTop: this.computedStyles.paddingTop,
        paddingBottom: this.computedStyles.paddingBottom,
        marginLeft: this.computedStyles.marginLeft,
        marginRight: this.computedStyles.marginRight,
        marginTop: this.computedStyles.marginTop,
        //marginBottom: this.computedStyles.collapseTopBottomMargins ? 0 : this.computedStyles.marginBottom,
        marginBottom: this.computedStyles.marginBottom,
        width: this.computedStyles.width,
        height: this.computedStyles.height,
        avoidBreakInside: this.styles["page-break-inside"] === "avoid" || this.styles["break-inside"] === "avoid",
        avoidBreakBefore: this.styles["page-break-before"] === "avoid" || this.styles["break-before"] === "avoid",
        columnCount: this.computedStyles.columnCount,
        columnGap: this.computedStyles.columnGap,
        columnFill: this.computedStyles.columnFill,
        overflowHidden: this.computedStyles.overflowHidden,
        drawHook: this.drawHook,
        mixinHook: this.mixinHook,
    };
    if (this.computedStyles.role) ret.role = this.computedStyles.role;
    return ret;
};

PDFBlockNode.prototype.generate = function (pdf) {
    return pdf.block(
        this._getOptions(),
        this.children.map(function (child) {
            return child.generate(pdf);
        }),
    );
};

module.exports = PDFBlockNode;
